export default __webpack_public_path__ + "static/media/granville02.5390ccc9.jpg";